import { withTranslation } from "i18n";
import { useRouter } from "next/router";
import React, { useState } from "react";
import { Badge, Button, Card, Col, Modal, Row } from "react-bootstrap";
import {
  commonStrigns,
  assessmentResultString,
  assessmentString,
  stringFiles,
} from "res/strings";
import { BsArrowLeftShort, BsArrowRightShort } from "react-icons/bs";
import { Box } from "styled-components/box";
import clsx from "clsx";

function ResultCard({
  t,
  title,
  description,
  present,
  duration,
  courses,
  startAtPersian,
  isEndedExam,
  endAtPersian,
  id,
  subject,
  isShowResponseForParent,
  isFinishedExam,
  statusAssignmentName,
}) {
  const router = useRouter();
  const courseNames = courses.map((course) => course.name);

  const routeName =
    router.pathname.search("onlineExam") === 1 ? "onlineExam" : "assignment";
  const routeID =
    router.pathname.search("onlineExam") === 1
      ? "onlineExamID"
      : "assignmentID";

  const checkAccessResultDetail = () => {
    if (routeName === "assignment" && present) {
      return true;
    } else {
      if (present && isFinishedExam && isEndedExam && isShowResponseForParent) {
        return true;
      }
    }
  };


  return (
    <Card
      className="my-2"
      onClick={() =>
        checkAccessResultDetail() &&
        router.push(
          `/${routeName}/[${routeID}]/Result`,
          `/${routeName}/${id}/Result`
        )
      }
    >
      <Card.Header
        className={clsx(
          present && isFinishedExam ? "bg-success" : "bg-danger",
          "d-flex text-white"
        )}
      >
        <p className="w-100 m-0 text-left">{title}</p>

        {statusAssignmentName && <Badge>{statusAssignmentName}</Badge>}
      </Card.Header>
      <Card.Body>
        <RowItem value={subject} label={t(assessmentString.subject)} />
        {duration && (
          <RowItem
            value={`${duration} دقیقه`}
            label={t(assessmentString.duration)}
          />
        )}
        <RowItem
          value={courses.length > 0 && courseNames.toString()}
          label={t(assessmentString.courseName)}
        />
        {description && (
          <RowItem
            value={description}
            label={t(assessmentString.description)}
          />
        )}
        <RowItem value={endAtPersian} label={t(assessmentString.endAt)} />
        <RowItem value={startAtPersian} label={t(assessmentString.startAt)} />
        {!isEndedExam && <p>{t(assessmentString.assessmentNotFinished)}</p>}
        {(!isShowResponseForParent  && routeName==="onlineExam") && (
          <p className="text-warning">
            {t(assessmentResultString.dontShowResponseToParent)}
          </p>
        )}
        {!present && (
          <Badge variant="warning">
            {t(assessmentResultString.assessmentNotJoin)}
          </Badge>
        )}

          {present && !isFinishedExam && 
           <Badge variant="warning" className="text-white">
            {t(assessmentResultString.assessmentNotSend)}
          </Badge>}
     
      </Card.Body>
      {(present && isFinishedExam && isEndedExam && isShowResponseForParent) && (
        <Card.Footer className="d-flex text-primary">
          {t(assessmentResultString.viewResult)}
        </Card.Footer>
      )}
    </Card>
  );
}

const RowItem = ({ label, value }) => {
  return (
    <Row>
      <Col className="d-flex p-0 m-0 text-left" xs={4}>
        {label && <p>{label}</p>}
      </Col>
      <Col className="d-flex p-0 m-0" xs={8}>
        <p className="text-left text-primary">{value}</p>
      </Col>
    </Row>
  );
};
export default withTranslation(stringFiles.common)(ResultCard);
